import { render, staticRenderFns } from "./ProductFeedback.vue?vue&type=template&id=6ab3e35d"
import script from "./ProductFeedback.vue?vue&type=script&lang=js"
export * from "./ProductFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ab3e35d')) {
      api.createRecord('6ab3e35d', component.options)
    } else {
      api.reload('6ab3e35d', component.options)
    }
    module.hot.accept("./ProductFeedback.vue?vue&type=template&id=6ab3e35d", function () {
      api.rerender('6ab3e35d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/OtherTargetMaintain/ProductFeedback.vue"
export default component.exports